import React from 'react'
import AcunetixMappingForm from './AcunetixMappingForm';
import AcunetixCredentialsForm from './AcunetixCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function AcunetixConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={AcunetixMappingForm}
            CredentialsForm={AcunetixCredentialsForm}
            componentName="Website"
            componentKey="websiteName"
        />
    )
}